import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-dot-indicator',
    templateUrl: './dot-indicator.component.html',
    standalone: false
})
export class DotIndicatorComponent {
  @Input() greenPosition: number;
  @Input() bluePosition: number;
  @Input() orangePosition: number;
}